<template>
  <div>
    <div>
      <div class="col-12 d-flex flex-wrap py-0">
        <div class="col-12 d-flex flex-wrap py-0">
          <div class="col-4 py-1">
            <Label
              :field="identifiantsFieldsProperties('uuid')"
              :value="content.uuid"
            />
          </div>

          <div class="col-4 py-0">
            <Label
              :field="identifiantsFieldsProperties('horanet_id')"
              :value="content.horanet_id"
              :text-color="getColorAlteredStatus('horanet_id')"
            />
          </div>

          <div class="col-4 py-0">
            <Label
              :field="identifiantsFieldsProperties('iresa_ids')"
              :value="content.iresa_ids"
              :text-color="getColorAlteredStatus('iresa_ids')"
            />
          </div>
        </div>

        <div class="col-8 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('kezia_id')"
              :value="content.kezia_id"
            />
          </div>
        </div>

        <div class="col-4 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('origin_app')"
              :value="content.origin_app"
              :text-color="getColorAlteredStatus('origin_app')"
            />
          </div>

          <div class="col-12  py-0">
            <Label
              :field="identifiantsFieldsProperties('sso_id')"
              :value="content.sso_id"
              :text-color="getColorAlteredStatus('sso_id')"
            />
          </div>
        </div>

        <div class="col-4 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('createTime')"
              :value="content.createTime"
            />
          </div>
        </div>

        <div class="col-4 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('anonymizeTime')"
              :value="content.anonymizeTime"
            />
          </div>
        </div>

        <div class="col-8 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('ucpaLicense.licenseNumber')"
              :value="license.licenseNumber"
            />
          </div>
        </div>

        <div class="col-4 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('ucpaLicense.end_date')"
              :value="license.end_date"
            />
          </div>
        </div>

        <div class="col-4 py-0">
          <div class="col-12 py-0">
            <Label
              :field="identifiantsFieldsProperties('idAto')"
              :value="content.idAto"
            />
          </div>
        </div>

        <div class="col-12 d-flex flex-wrap py-2 grey lighten-4 mt-8 mx-8">
          <DigitalAccount
            v-model="newContent['digital_account']"
            :field="identifiantsFieldsProperties('digital_account')"
            :editable="!content.digital_account"
            :email="content.email"
            :content="content"
            :contexts="userContexts()"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Label from './Label.vue';
import DigitalAccount from './DigitalAccount.vue';

import { identifiantsFieldsProperties } from '../../configs/forms';
import { utils } from '@/mixins/index';

import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  name: 'IdentifiantsFormLB',
  components: { Label, DigitalAccount },
  mixins: [utils],
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contentAlteredValues: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return { newContent: this.$props.content };
  },
  computed: {
    license () {
      if (this.$props.content.licenses && this.$props.content.licenses.length) {
        return this.$props.content.licenses[0].data;
      }

      return {};
    }
  },
  watch: {
    content () {
      this.newContent = this.content;
    }
  },
  methods: {
    identifiantsFieldsProperties: identifiantsFieldsProperties,

    userContexts () {
      let contexts = (this.newContent.contexts || []).map(c => c.value.replace('IRESA_', ''));

      if (this.newContent.context) {
        contexts = [this.newContent.context.replace('IRESA_', '')];
      }

      return contexts;
    },
    getColorAlteredStatus (field) {
      let color = 'black';

      if (this.contentAlteredValues) {
        if (field === 'iresa_ids') {
          if (this.contentAlteredValues.iresa_ids) {
            const colors = {};
            Object.keys(this.contentAlteredValues.iresa_ids).forEach(k => colors[k] = 'green');
            return colors;
          }
        }
        if (this.contentAlteredValues[field]) {
          color = 'green';
        }
      }
      return color;
    }
  }
};
</script>

<style >
</style>
